import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('permessi');
export const actions = helper.createActions('permessi', actionTypes);
